import { styled } from '@zenbusiness/zui/styles';

const ItemWrapperStyle = ({ theme }) => ({
  width: '100%',
  height: 'auto',
  padding: '18px 0',
  display: 'flex',
  borderBottom: '1px solid',
  borderColor: theme.palette.border.main,
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const ItemWrapper = styled('div')(ItemWrapperStyle);
